.container {
  display: block;
}

.noteGrid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}

.correct {
  color: var(--tuna-palette-success-main);
  font-weight: 500;
}

.wrong {
  color: var(--tuna-palette-error-main);
  font-weight: 500;
}
